import { CourseDTO, CourseFlatDTO } from "../domain/models/dto/CourseDTO";
import { ICourseFlat, CourseFlatCollection } from "../domain/models/Course";
import { CourseService } from "../domain/services/CourseService";
import { CourseFlatMapper } from "../mappers/CourseFlatMapper";
import { BaseServiceImpl } from "./BaseServiceImpl";
import { LanguageServiceImpl } from "./LanguageServiceImpl";

export class CourseServiceImpl
    extends BaseServiceImpl
    implements CourseService
{
    static _instance: CourseService;
    private readonly courseEndpoint = "/api/v1/courses";

    private constructor() {
        super();
    }

    static getInstance(): CourseService {
        if (!CourseServiceImpl._instance) {
            CourseServiceImpl._instance = new CourseServiceImpl();
        }
        return CourseServiceImpl._instance;
    }

    async getAllCourses(
        currentPage: number,
        currentLimit: number,
        filtersDTO: CourseDTO = {} as CourseDTO,
    ): Promise<CourseFlatCollection> {
        try {
            let url = `${this.courseEndpoint}?page=${currentPage}&limit=${currentLimit}&lang=${
                LanguageServiceImpl.getInstance().currentLang
            }`;
            Object.entries(filtersDTO).forEach(([key, value]) => {
                if (key && value !== null && value !== undefined) {
                    url += `&${key}=${value}`;
                }
            });

            const result = await this.get<CourseFlatCollection>(url);
            return {
                ...result,
                rows: result.rows.map((dto) =>
                    new CourseFlatMapper().fromDTO(dto),
                ),
            };
        } catch (err) {
            console.log("Error in CourseServiceImpl.getAllCourses");
            console.log(err);
            return { rows: [], totalRows: 0, totalPages: 0 };
        }
    }

    async getCourseById(id: string): Promise<ICourseFlat | null> {
        try {
            if (!id) return null;

            const dto = await this.get<CourseFlatDTO>(
                `${this.courseEndpoint}/${id}?lang=${LanguageServiceImpl.getInstance().currentLang}`,
            );
            return new CourseFlatMapper().fromDTO(dto);
        } catch (err) {
            console.log("Error in CourseServiceImpl.getCourseById");
            console.log(err);
            return null;
        }
    }
}

export function courseServiceFactory(): CourseService {
    return CourseServiceImpl.getInstance();
}
